module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/baby-sitting/child1-5248b1f9f71260f59b9c0b9263e6c747.svg";